import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleDeleteDraftRelease: () => void;
}
function DeleteDraftReleaseModal({ open = false, onClose, handleDeleteDraftRelease }: IProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary p-8 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold leading-tight">
              Are you sure you want to Delete the Draft release?
            </h1>
          </div>

          <button type="button" onClick={onClose} className="p-3">
            <CloseIcon className="h-4 w-4 text-white" />
          </button>
        </div>
        <section className="mt-6 w-full font-satoshi text-sm font-450 leading-tight text-white text-opacity-70">
          By deleting the release, you will not be able to publish your Magnet through this draft. You can open up
          another draft as long as there are remaining Magnets to release.
        </section>
        <div className="mt-10 flex justify-end gap-3">
          <Button variant="whiteOutline" text="CANCEL" onClick={onClose} additionalClasses="text-xs" />
          <Button
            variant="magnetiqSolid"
            text="DELETE DRAFT RELEASE"
            onClick={handleDeleteDraftRelease}
            additionalClasses="text-xs"
          />
        </div>
      </div>
    </Modal>
  );
}

export default DeleteDraftReleaseModal;
